import { kManualMargins } from "../constants";
import { QBoxLayout } from "./QBoxLayout";
import { QXMLObject } from "./QXMLObject";

export class QBackgroundArea extends QXMLObject {
  constructor() {
    super();
    this.fContextId = null;
    this.fLayoutList = null;
  }

  InitBackgroundArea() {
    this.fLayoutList = [];
  }

  LoadFromJSON(json) {
    var layouts = json["layouts"];
    for (var layout of layouts) {
      var nLayout = new QBoxLayout();
      nLayout.LoadFromJSON(layout);
      var newLayout = nLayout.Clone({ includeId: true });
      if (newLayout.GetMarginMode() !== kManualMargins) newLayout.SetDefaultBackgroundMargins();
      this.AddLayout(newLayout);
    }
  }

  OutputToJSON() {
    var json = {};
    var layouts = [];
    this.fLayoutList.forEach(layout => {
      layout.SetDBObjClassName("Box");
      var jsonLayout = layout.SaveToJSON();
      layouts.push(jsonLayout);
    });
    json["layouts"] = layouts;
    json["contextId"] = this.fContextId;
    return json;
  }

  SetLayout(idx, layout) {
    this.fLayoutList[idx] = layout;
  }

  GetLayouts() {
    return this.fLayoutList;
  }

  SetLayouts(layouts) {
    this.fLayoutList = layouts;
  }

  AddLayout(layout) {
    this.fLayoutList.push(layout);
  }

  Clone() {
    const clone = new QBackgroundArea();
    clone.fContextId = this.fContextId;
    clone.fLayoutList = this.fLayoutList.map(layout => layout.Clone({ includeId: true }));
    return clone;
  }

  RemoveLayout(layout) {
    const index = this.fLayoutList.indexOf(layout);
    if (index > -1) {
      this.RemoveLayoutAtIndex(index);
    }
    return index;
  }

  RemoveLayoutAtIndex(index) {
    this.fLayoutList.splice(index, 1);
  }

  InsertLayout(layout, index) {
    this.fLayoutList.splice(index, 0, layout);
  }

  GetIndexOfLayout(aLayout) {
    return this.fLayoutList.indexOf(aLayout);
  }

  ReplaceLayout(oldLayout, newLayout, index) {
    var oldIndex = this.GetIndexOfLayout(oldLayout);
    this.RemoveLayoutAtIndex(oldIndex);
    this.InsertLayout(newLayout, index);
  }
}
